import { safeRequestIdleCallback, safeCancelIdleCallback } from './requestIdleCallbackPolyfill'

interface IdleIntervalOptions {
  interval: number
  timeout?: number // Max wait time if browser stays busy
}

export const createIdleInterval = (
  callback: () => void, 
  { interval, timeout = 2000 }: IdleIntervalOptions
) => {
  let isActive = true
  let timeoutId: number | null = null
  let idleCallbackId: any = null
  
  const scheduleNext = () => {
    if (!isActive) return
    
    timeoutId = window.setTimeout(() => {
      // Execute when idle, but with a timeout guarantee
      idleCallbackId = safeRequestIdleCallback(
        (deadline) => {
          if (isActive) {
            callback()
            scheduleNext()
          }
        },
        { timeout } // Force execution after timeout ms
      )
    }, interval)
  }
  
  scheduleNext()
  
  return () => {
    isActive = false
    if (timeoutId) clearTimeout(timeoutId)
    if (idleCallbackId) safeCancelIdleCallback(idleCallbackId)
  }
}